// This file is generated automatically by scripts/generate-icon.js. Don't modify it.

import MyList from '../_raw/ui/icon_my_list.svg';
import withIconProps from '../withIconProps';

export default withIconProps(MyList);
